export const SET_GUILD_MASTER_DATA = 'SET_GUILD_MASTER_DATA';
export const setGuildMasterData = (guildData) => ({
    type: SET_GUILD_MASTER_DATA,
    payload: guildData
});
